export default __webpack_public_path__ + "assets/images/82fda6b8c9e46ff635a20eac3a27f131.png";